import { Outlet } from 'react-router-dom'

/**
 * Layout route for everything under `/field`.
 *
 * Deliberately thin. The shell is applied per screen rather than here, because
 * field screens differ in whether they want chrome at all — a full-bleed map
 * with a pin needs the whole viewport, while a list wants a header and tabs.
 * Wrapping everything in one fixed frame here would force every screen to fight
 * it.
 *
 * Note what this does NOT do: it does not gate on viewport. `DesktopOnlyOutlet`
 * latches its verdict per pathname because its fallback is destructive — it
 * replaces the screen with a notice, so a resize mid-edit would lose work.
 * Field routes are legal at every viewport, so there is nothing to latch and
 * nothing to lose. The device only influences where `/` sends someone, and even
 * that is overridable.
 */
const FieldOutlet = () => <Outlet />

export default FieldOutlet
